import { render } from "./svg-copy.vue?vue&type=template&id=294e6688&scoped=true"
import script from "./svg-copy.vue?vue&type=script&lang=ts"
export * from "./svg-copy.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-294e6688"

export default script